import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  privilege: {
    display: 'grid',
    textAlign: 'left',
    gridTemplateColumns: '3fr 2fr 2fr',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '3fr 2fr'
    },
    alignItems: 'center'
  },
  pendingPrivilege: {
    display: 'grid',
    textAlign: 'left',
    gridTemplateColumns: '3fr 2fr 2fr 2fr',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '3fr 2fr'
    }
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginRight: 'initial'
    }
  },
  emailColumn: {
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    minWidth: '33%'
  },
  conditionalColumn: {
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  emailField: {
    flex: 1,
    minWidth: 'min(100%, 300px)'
  },
  newUserGrid: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2),
    '& .MuiFormHelperText-filled': {
      height: 0,
      marginBottom: '-3px'
    }
  }
}));